export default import.meta.ROLLUP_FILE_URL_D__SKMOt;